export enum ErrorCode {
  Lock = 1,
  Unlock = 2,
  Unknown = 3,
  NotDeletable = 4,
}

export const ErrorTemplate: { [key in ErrorCode]: string } = {
  [ErrorCode.Lock]: '%{name} is locked due to publishing. It will unlock as soon as the publish is complete.',
  [ErrorCode.Unlock]: '%{name} was unlocked.',
  [ErrorCode.Unknown]: 'An unexpected error has occurred.',
  [ErrorCode.NotDeletable]: 'Failed to delete %{name}.',
};
